// skipcq: JS-W1028
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { logout } from '../../utils/firebase';
import { sidebarStack, VINTAGE_SIDEBAR } from '../../utils/vintageSurfaces';

/**
 * @param {{ showLogout?: boolean }} props
 */
export default function LoginHeader({ showLogout = false }) {
  return (
    <Box
      sx={{
        ...sidebarStack(VINTAGE_SIDEBAR.main),
        color: VINTAGE_SIDEBAR.contrastText,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        py: 2,
        px: { xs: 2, sm: 4 },
        borderBottom: '1px solid rgba(0, 0, 0, 0.28)',
      }}
    >
      <Typography
        variant="h6"
        noWrap
        component="div"
        sx={{
          fontFamily: '"Henny Penny", cursive',
          fontWeight: 400,
          color: '#F9DA85',
        }}
      >
        {"Brewhouse"}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexShrink: 0,
          ml: 'auto',
        }}
      >
        {showLogout ? (
          <Button type="button" variant="text" color="inherit" onClick={logout}>
            Logout
          </Button>
        ) : null}
        <img src={'/logo.png'} alt={"I'd Tap That logo"} width="40" />
      </Box>
    </Box>
  );
}
